import { Controller } from "@hotwired/stimulus"

// Every language of a page in one form: the picker swaps which one you are
// typing, the save sends them all (head_translations[pt], [en]...). Each
// option is ticked once its language has a body, so what is still missing
// shows without opening it.
//
// Ships with fire, registered by the host as "locales" — see HOTWIRE.md.
// Without it the form opens on the default language and stays there: every
// other pane is `hidden` and the picker that unhides them is dead.
export default class extends Controller {
  static targets = ["select", "pane"]

  connect() {
    this.mark()
  }

  show() {
    const lang = this.selectTarget.value
    this.paneTargets.forEach((pane) => pane.classList.toggle("hidden", pane.dataset.lang !== lang))
  }

  // On every keystroke: cheap, and the tick is the whole point of the picker.
  mark() {
    this.paneTargets.forEach((pane) => {
      const written = pane.querySelector("textarea").value.trim().length > 0
      const option = this.selectTarget.querySelector(`option[value="${pane.dataset.lang}"]`)
      option.textContent = written ? `${option.dataset.label} ✓` : option.dataset.label
    })
  }
}
